import { render, staticRenderFns } from "./KnProductSatCodes.vue?vue&type=template&id=88758dca"
import script from "./KnProductSatCodes.js?vue&type=script&lang=js&external"
export * from "./KnProductSatCodes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports